/* global BlitzzCobrowse */
/* import Library and custom made hooks*/
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import moment from "moment";
import { get, isEmpty } from "lodash";
import { useDidMount } from "../../hooks/useDidMountEffect";
import useLanguageChange from "../../hooks/useLanguageChange";

/* Import all constants */
import {
    CALL_BODY_SCREEN,
    CONNECTING_SCREEN,
    DISABLE,
    ENABLED,
    EXTRACT_TEXT_VIEW,
    FULL_DATE_FORMAT,
    JOIN_MEETING_START_TIME_FORMATE,
    LOCAL_STORAGE_KEYS,
    MARKUP_VIEW,
    SCHEDULE_SESSION_ERROR_CODE,
} from "../../constants/Constants";
import { CALL_DATA, DOCUMENT_VISIBILITY_STATE, GLOBAL_MEETING_DATA, PublicVariables } from "../../constants/PublicVariables";

/* Import Services/Shared/Actions  */
import { isSilentObserverAvailable, setSCSSVariables, setShowLoading, setShowMeBackground } from "../../shared/function";
import {
    remainingCountUpdate,
    isMaxLimitReachedForUploadFiles,
    isOnlyUploadImageAvailable,
    getSessionId,
    dualStreamEnabled,
} from "../../shared/utility";
import { getCountryList } from "../../actions/onLoadFunctionAction";
import { handleJoinMeetingAPI } from "../../actions/joinMeetingAction";
import { setLanguagesInDataReducer } from "../../actions/languageAction";
import storage from "../../services/storage";
import { setSelectedSmsCountry, setSelectedWhatsAppCountry } from "../../reducers/invite-reducer";
/* Import Components */
import PrivacyPolicy from "./ConnectingScreen/PrivacyPolicy/PrivacyPolicy";
import InviteParticipant from "./CallTopbar/InviteParticipant/inviteParticipant";
import JoinMeeting from "./ConnectingScreen/JoinMeeting/JoinMeeting";
import CallFooter from "./CallFooter/CallFooter";
import CallTopbar from "./CallTopbar/CallTopbar";
import CallBody from "./CallBody/CallBody";
import BottomMenuBar from "../BottomMenuBar/BottomMenuBar";
import BookmarkDrawer from "../Bookmarks/BookmarkDrawer";
import AskGuestUserPopup from "./ConnectingScreen/JoinMeeting/AskGuestUserPopup";
import NotesDrawer from "../Notes/NotesDrawer";
import ChatDrawer from "../Chat/ChatDrawer";
import AskAIDrawer from "../AskAI/AskAIDrawer";
import UploadFileContainerDrawer from "../UploadFiles/UploadFileContainerDrawer";
import LocationPermissionPopup from "./ConnectingScreen/JoinMeeting/LocationPermissionPopup";
import VideoPermissionPopup from "../Twilio/VideoCall/VideoPermissionPopup.jsx";
import { DEFAULT_COUNTRY_CODE } from "../../constants/InviteConstants";
import AudioErrorModals from "../Twilio/AudioCall/AudioErrorModals.jsx";
import ParticipantsListDrawer from "../ParticipantsList/ParticipantsListDrawer.jsx";
import uploadFilesService from "../../services/uploadFilesService";
import { SELECTED_SCREEN, SUB_SCREEN, UPLOAD_FILE_DATA_TRACK_STATUS } from "../../constants/UploadFilesConstants";
import ImageContainerDrawer from "../ImageContainer/ImageContainerDrawer";
import scheduleSessionService from "../../services/scheduleSessionService";
import MobileSessionInfo from "./CallTopbar/SessionInfo/MobileSessionInfo";
import TimerComponent from "./CallTopbar/SessionInfo/TimerComponent";
import DeviceBattery from "../Battery/DeviceBattery";
import ExtractText from "../ExtractText/ExtractText";
import ExtractTextCopyModal from "../ExtractText/ExtractTextCopyModal";
import DeviceNetwork from "../Network/DeviceNetwork";
import { LogFirebase } from "../../services/firestore";
import { FIREBASE_EVENT_CATEGORY, FIREBASE_LOG_KEY, FIREBASE_LOG_VALUE } from "../../constants/FirebaseConstants";
import { changeUploadFileScreen, updateImagesArray } from "../../reducers/uploadFile-reducer";
import { checkPublishVideoOnExit, sendDataForRejoinCallOfflineModeUser } from "../../shared/dataTrackFunction";
import UploadLimitReachedModal from "../UploadFiles/UploadLimitReatchedModal";
import DownloadImageFailedModal from "../CommonModals/DownloadImageFailedModal";
import OrientationChangeModal from "../CommonModals/OrientationChangeModal";
import CustomToastModal from "../CommonModals/CustomToastModal";
import AppDownloadModal from "../CommonModals/AppDownloadModal.jsx";
import SilentObserverNotificationModal from "../SilentObserver/SilentObserverNotificationModal.jsx";
import MediatePopup from "../SilentObserver/MediatePopup.jsx";
import googleEvent from "../../services/googleEvent.js";
import { EVENT_NAME } from "../../constants/GTagConstants.js";
import ScheduleSessionModal from "../CommonModals/ScheduleSessionModal.jsx";
import ProgressLoader from "./ProgressLoader.jsx";
import EndCall from "../EndCall/EndCall.jsx";
import LastUserDisconnectPopup from "../EndCall/LastUserDisconnectPopup.jsx";
import livePointerService from "../LivePointer/livePointerService.js";
import Markup from "../Markup/Markup.jsx";
import ScreenSharePopUp from "../Twilio/ScreenShare/ScreenSharePopUp.jsx";
import SessionInfoSidebar from "./CallTopbar/SessionInfo/SessionInfoSidebar.jsx";
import UnSupportedBrowserModal from "../CommonModals/UnSupportedBrowserModal.jsx";
import RoomErrorModals from "../CommonModals/RoomErrorModals.jsx";
import { checkSupportedBrowsers } from "../CommonModals/CommonUtils.js";
import {
    setIsBookmarkOpen,
    setIsChatDrawerOpen,
    setIsNotesDrawerOpen,
    setIsParticipantDrawerOpen,
    setIsRoomConnected,
    setIsHideVideo,
    setShouldAutoAcceptPrivacyPolicy,
} from "../../reducers/common-reducer.js";
import ConfirmExitMarkupModal from "../CommonModals/confirmExitMarkupModal.jsx";
import TwilioRoomEvent from "../Twilio/TwilioRoomEvent.jsx";
import { useTwilioRoom } from "../../providers/useTwilioRoomProvider.jsx";
import { publishVideo, unpublishVideo } from "../Twilio/VideoCall/VideoUtils.js";
import { createEnableAudiotracks } from "../Twilio/twilioCallUtility.js";
import Measurement from "../Measurement/Measurement.jsx";
import { UK_COUNTRY_CODE_NEW, UK_COUNTRY_CODE_OLD } from "../../constants/LanguageConstants.js";
import arMarkupService from "../../services/MarkupService/arMarkupService.js";
import { Beforeunload } from "../UI/WindowUnloadHandler/Beforeunload.jsx";
import ARMarkupStatusPopup from "../ARMarkup/ARMarkupStatusPopup.jsx";
import { checkCallSettingPermissionsOnLoad } from "./CallTopbar/CallSettings/CallSettingUtils.js";
import {
    RemoveAllParticipantsByHost,
    RemoveIndividualParticipantByHost,
    UnableToJoinCallModal,
} from "../ParticipantsList/HostControlledParticipants/RemoveParticipantByHostModal.jsx";
import { rejoinNotllowed } from "../ParticipantsList/HostControlledParticipants/HostControlledParticipantUtils.js";
import CommonNotificationModal from "../CommonModals/CommonNotificationModal.jsx";
import IosPlayPauseIconModal from "../CommonModals/IosPlayPauseIconModal.jsx";
import LiveCaptions from "../LiveCaptions/LiveCaptions.jsx";
import AudioTranslationDrawer from "../AudioTranslation/AudioTranslationDrawer.jsx";
import AudioTranslationStatus from "../AudioTranslation/AudioTranslationStatus.jsx";
import RequestPermissionForMicOrCameraModal from "../CommonModals/RequestPermissionForMicOrCameraModal.jsx";
import CallSettingDrawer from "./CallTopbar/CallSettings/CallSettingDrawer.jsx";
import OfflineMode from "../OfflineMode/OfflineMode.jsx";
import { resetOfflineModeReducer } from "../../reducers/offline-mode-reducer.js";
import OfflineModeAlertBox from "./CallTopbar/SessionInfo/OfflineModeAlertBox.jsx";
import ConditionalLDProvider from "../../providers/ConditionalLDProvider.jsx";
import LDFlagsSync from "./LDFlagsSync.jsx";

const CallScreens = () => {
    //#region Local State
    const dispatch = useDispatch();
    const params = useParams();
    const sessionId = getSessionId(params?.sessionId);

    // State to track when LD flags are ready
    const [ldFlagsReady, setLdFlagsReady] = useState(false);

    // Refs to track if initialization has already occurred (prevents duplicate initialization)
    const googleEventInitializedRef = useRef(false);
    const cobrowseInitializedRef = useRef(false);
    const prevExpandViewRef = useRef(false); // Track previous expandView state for auto live pointer collapse detection

    /* Destructuring values from the 'onLoadData' reducer of the Redux store */
    const { isCompanyAvailableData, isCompanyAvailableError, privacyPolicyLoading, privacyPolicyData, privacyPolicyError, getCountryListData } =
        useSelector((state) => state.onLoadData);

    const { isInviteModalOpen } = useSelector((state) => state.inviteParticipant);
    const { joinMeetingData, joinMeetingError, joinMeetingLoading } = useSelector((state) => state.joinMeeting);
    const { subScreenToShow } = useSelector((state) => state.uploadFile);
    const { markupInprogress, markupLiveStream } = useSelector((state) => state.markup);

    /* Initializing state variables for privacy policy modal visibility */
    const [showPrivacyPolicyModal, setShowPrivacyPolicyModal] = useState(false);
    const [showUploadLimitReachedModal, setShowUploadLimitReachedModal] = useState(false);

    /* Initializing state variables for invite modal visibility */
    const [changeConnectingScreenStep, setChangeConnectingScreenStep] = useState(CONNECTING_SCREEN.ENTER_SESSIONID_SCREEN);
    const {
        countinueWithWeb,
        showLocationPermissionPopup,
        isRemoteParticipantJoined,
        strStartsIn,
        currentCallBodyScreen,
        isCallDisconnected,
        confirmDisconnectCall,
        showCallDisconnectedPopup,
        expandView,
        isRoomConnected,
        isHideVideo,
        removeParticipant,
        isUnableToJoinCallModalOpen,
        isIosPlayPauseIconModalOpen,
        shouldAutoAcceptPrivacyPolicy,
    } = useSelector((state) => state.commonReducer);
    const {
        notAllowedCamera,
        audioErrorModal,
        isConfirmVideoModalOpen,
        startLocalVideo,
        isLocalUserScreenSharing,
        startLocalAudio,
        screenSharingUsers,
        videoStreamingUsers,
        showPopupForPlayAudio,
    } = useSelector((state) => state.twilioEvents);

    const { room } = useTwilioRoom();
    /*Destructuring values from the 'extractTextReducer' reducer of the Redux store */
    const { extractTextInprogress, openCopyTextModal } = useSelector((state) => state.extractText);

    /*Destructuring values from the 'livePointer' reducer of the Redux store */
    const { pointerOn } = useSelector((state) => state.livePointer);

    /*Destructuring values from the 'imageContainerReducer' reducer of the Redux store */
    const { containerImagesArray } = useSelector((state) => state.imageContainerReducer);

    /*Destructuring values from the 'silentObserver' reducer of the Redux store */
    const { mediate } = useSelector((state) => state.silentObserver);

    /* Destructuring values from the 'onLoadData' reducer of the Redux store */
    const { isRoomParticipantExceed } = useSelector((state) => state.onLoadData);

    /* Destructuring values from the 'offlineMode' reducer of the Redux store */
    const { isOfflineModeActive, localUserOfflineModeIdentity, isOfflineModeInProgress } = useSelector((state) => state.offlineMode);

    /* custome hook for getting updated localized value object for entire project 
    This will give localize value object for selected language
    Also will give updated localized value object when language change */
    const localisedValues = useLanguageChange();

    //#endregion Local State

    //#region Local and Custom Hooks

    // Initialize Google Event Tracking when LD flags are ready
    // Note: Using PublicVariables.ldFlags instead of ldFlags hook since this component is outside LD context
    useEffect(() => {
        // Prevent duplicate initialization
        if (googleEventInitializedRef.current) {
            return;
        }

        if (PublicVariables.ldFlags?.captureDeviceAndGoogleEvent && privacyPolicyData?.domainId) {
            const googleEvent = require("../../services/googleEvent").default;
            const { EVENT_NAME, EXTRA_PARAM_NAME } = require("../../constants/GTagConstants");
            const { GLOBAL_MEETING_DATA } = require("../../constants/PublicVariables");

            if (!googleEvent.isInitialized) {
                googleEvent.initializeGoogleTagManager();
            }

            // Log initial events
            googleEvent.logEvent(EVENT_NAME.LANGUAGE, EXTRA_PARAM_NAME.SELECTED_LANGUAGE, PublicVariables.currentLanguageObj.languageCode);
            googleEvent.logEvent(EVENT_NAME.CONNECT_TAPPED, EXTRA_PARAM_NAME.ENTERED_NUMBER_OF_DIGITS, GLOBAL_MEETING_DATA.sessionId.toString());
            googleEvent.logEvent(EVENT_NAME.VALID_CODE_ENTERED);

            // Mark as initialized
            googleEventInitializedRef.current = true;
        }
    }, [ldFlagsReady, privacyPolicyData?.domainId]);

    // Initialize Cobrowse when LD flag is enabled
    // Note: Using PublicVariables.ldFlags instead of ldFlags hook since this component is outside LD context
    useEffect(() => {
        // Prevent duplicate initialization
        if (cobrowseInitializedRef.current) {
            return;
        }

        if (PublicVariables.ldFlags?.cbForBlitzzPortal && window.location.hostname !== "localhost" && privacyPolicyData?.domainId) {
            const { COBROWSE_LICENSE_KEY, COBROWSE_SDK_URL } = require("../../constants/Constants");
            const { GLOBAL_MEETING_DATA } = require("../../constants/PublicVariables");

            let blitzz;
            let st = document.createElement("script");
            st.src = COBROWSE_SDK_URL;
            st.async = true;
            let tx = document.getElementsByTagName("script")[0];
            tx.parentNode.insertBefore(st, tx);

            st.onload = function () {
                if (!blitzz) {
                    try {
                        blitzz = new BlitzzCobrowse({});
                        let referenceName = `Guest ${GLOBAL_MEETING_DATA.sessionId}`;
                        if (GLOBAL_MEETING_DATA.isAgent) {
                            referenceName = `Host ${GLOBAL_MEETING_DATA.sessionId}`;
                        }
                        blitzz.initialize({
                            license: COBROWSE_LICENSE_KEY,
                            reference: referenceName,
                        });
                    } catch (e) {
                        console.info("Failed to initialize BlitzzCobrowse:", e);
                    }
                }
            };

            st.onerror = function () {
                console.info("Failed to load BlitzzCobrowse script.");
            };

            // Mark as initialized
            cobrowseInitializedRef.current = true;
        }
    }, [ldFlagsReady, privacyPolicyData?.domainId]);

    /* Handle the schedule session and show a modal when join api given an error with 1063 session code */
    useEffect(() => {
        if (joinMeetingError?.code === SCHEDULE_SESSION_ERROR_CODE) {
            const formatedDate = moment(joinMeetingError.title, JOIN_MEETING_START_TIME_FORMATE).format(FULL_DATE_FORMAT);
            scheduleSessionService.showUpcomingEvent(formatedDate);
        }
    }, [joinMeetingError]);

    useEffect(() => {
        if ([CALL_BODY_SCREEN.UPLOAD_FILE_SCREEN, CALL_BODY_SCREEN.NOTIFY_SCREEN].includes(currentCallBodyScreen)) {
            dispatch(setIsBookmarkOpen(false));
            dispatch(setIsChatDrawerOpen(false));
            dispatch(setIsNotesDrawerOpen(false));
            dispatch(setIsParticipantDrawerOpen(false));
        }
    }, [currentCallBodyScreen]);

    useEffect(() => {
        if (privacyPolicyData) {
            /* Set a LdFlag and featureFlag after privacy api call successfully */
            remainingCountUpdate(privacyPolicyData);

            if (privacyPolicyData?.sessionConfigurations) {
                PublicVariables.featureFlag = privacyPolicyData?.sessionConfigurations;
                PublicVariables.isOnlyUploadImageMeet = isOnlyUploadImageAvailable();
            }

            GLOBAL_MEETING_DATA.domainInfo.edition = privacyPolicyData?.edition;

            if (isMaxLimitReachedForUploadFiles()) {
                /*  If upload only flow with file upload limit reached, then do not process for Privacy policy and/or enter guest name */
                /*  For this case we will show upload limit reached popup */
                setShowUploadLimitReachedModal(true);
                setShowLoading(false);
            } else {
                /*  If upload only flow with file upload limit do not reached, then and only process for Privacy policy and/or enter guest name */

                /* privacy modal show in guest only if privacy popup is enable and pid is not availabel in url */
                if (
                    GLOBAL_MEETING_DATA.isGuest &&
                    privacyPolicyData?.enablePolicyPopup &&
                    GLOBAL_MEETING_DATA.privacyPolicyAgreed === undefined &&
                    !GLOBAL_MEETING_DATA.pid
                ) {
                    if (rejoinNotllowed()) {
                        // if true then do not allow user to connect call
                        console.log("do nothning");
                    } else {
                        setShowPrivacyPolicyModal(true);
                    }
                }

                /* go to the enter guest name screen when enable privacy popup is disable and pid is not available in url */
                if (
                    GLOBAL_MEETING_DATA.isGuest &&
                    privacyPolicyData?.enablePolicyPopup === false &&
                    GLOBAL_MEETING_DATA.enablePolicyPopup === undefined &&
                    !GLOBAL_MEETING_DATA.pid
                ) {
                    if (rejoinNotllowed()) {
                        // if true then do not allow user to connect call
                        console.log("do nothning");
                    } else {
                        GLOBAL_MEETING_DATA.enablePolicyPopup = false;
                        checkForGuestName();
                    }
                }
            }

            dispatch(setLanguagesInDataReducer(privacyPolicyData, true));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [privacyPolicyData]);

    useEffect(() => {
        if (isCallDisconnected) {
            setChangeConnectingScreenStep(CONNECTING_SCREEN.ENTER_SESSIONID_SCREEN);
        }
    }, [isCallDisconnected]);

    useEffect(() => {
        if (joinMeetingData) {
            /* 
            as we have no public variable feature flags set as soon as join meeting api response received at this point 
            we are using joinmeetingdata values to achive requirement    
            */
            if (joinMeetingData && isOfflineModeActive) {
                CALL_DATA.isOfflineMode = false;
                uploadFilesService.resetFlags();
                dispatch(resetOfflineModeReducer());
                LogFirebase("OfflineMode", "user_reconnect_call", {
                    previous_offline_mode_user_identity: localUserOfflineModeIdentity,
                    current_user_identity: CALL_DATA.localIdentity,
                });
                setTimeout(() => {
                    sendDataForRejoinCallOfflineModeUser(localUserOfflineModeIdentity);
                }, 4000);
            }
            const featureFlag = joinMeetingData?.sessionConfigurations;
            if (featureFlag?.LIVEVIDEO === DISABLE && featureFlag?.ENABLESCREENSHARE === DISABLE && featureFlag?.UPLOADFILE === ENABLED) {
                dispatch(setIsRoomConnected(true)); /* Set variable to true to show call end screen in CallBody.js */
                setChangeConnectingScreenStep(CONNECTING_SCREEN.UPLOAD_FILES_SCREEN);
            } else {
                setChangeConnectingScreenStep(CONNECTING_SCREEN.VIDEO_SCREEN);
            }
        }
    }, [joinMeetingData]);

    /* handle loader based on privacy policy popup and enter guest name enable or disable */
    useEffect(() => {
        const showDirectWaitingScreenForGuest =
            !GLOBAL_MEETING_DATA.isAgent &&
            !privacyPolicyData?.enablePolicyPopup &&
            privacyPolicyData?.sessionConfigurations?.ASKGUESTNAME !== ENABLED;
        const showDirectWaitingScreenForAgent = GLOBAL_MEETING_DATA.isAgent;
        if (
            (showDirectWaitingScreenForGuest || showDirectWaitingScreenForAgent || GLOBAL_MEETING_DATA.pid) &&
            (joinMeetingData || joinMeetingError || rejoinNotllowed()) // if rejoinNotllowed true then do not allow user to connect call
        ) {
            const loader = document.getElementById("page-loader");
            if (loader) {
                loader.classList?.add("page-loader-hide");
            }
        }

        const showDirectEnterGuestNameScreen =
            !GLOBAL_MEETING_DATA.isAgent &&
            !privacyPolicyData?.enablePolicyPopup &&
            privacyPolicyData?.sessionConfigurations?.ASKGUESTNAME === ENABLED;
        const showDirectEnterSessionCodeScreen =
            !GLOBAL_MEETING_DATA.isAgent &&
            privacyPolicyData?.enablePolicyPopup &&
            privacyPolicyData?.sessionConfigurations?.ASKGUESTNAME !== ENABLED;
        const showEnterSessionCodeAndGuestNameScreen =
            !GLOBAL_MEETING_DATA.isAgent &&
            privacyPolicyData?.enablePolicyPopup &&
            privacyPolicyData?.sessionConfigurations?.ASKGUESTNAME === ENABLED;
        if (
            (showDirectEnterGuestNameScreen || showDirectEnterSessionCodeScreen || showEnterSessionCodeAndGuestNameScreen) &&
            !GLOBAL_MEETING_DATA.pid
        ) {
            const loader = document.getElementById("page-loader");
            if (loader) {
                const brandLogoImgTag = document.getElementById("brandLogo");
                if (brandLogoImgTag) {
                    loader.classList?.add("page-loader-hide");
                }
            }
        }
    }, [privacyPolicyData, joinMeetingData, joinMeetingError]);

    /* Handle join meeting api based on pid - call directly join meeting api if pid is available in url and is company and privacy api success */
    useEffect(() => {
        if (privacyPolicyData && GLOBAL_MEETING_DATA.pid && (GLOBAL_MEETING_DATA.isCustomDomain || isCompanyAvailableData)) {
            dispatchJoinMeeting();
        }
        checkSupportedBrowsers();
    }, [isCompanyAvailableData, privacyPolicyData]);

    useDidMount(() => {
        if (!joinMeetingData && !joinMeetingLoading && privacyPolicyData?.sessionConfigurations && GLOBAL_MEETING_DATA.isAgent) {
            callJoinMeetingAPI();
        }
    }, [privacyPolicyData?.sessionConfigurations]);

    useEffect(() => {
        if (sessionId && isCompanyAvailableData) {
            dispatch(getCountryList());
        }
    }, [isCompanyAvailableData]);

    useEffect(() => {
        if (isEmpty(privacyPolicyData) || isEmpty(getCountryListData)) return;

        // setting default country code
        let defaultCountry = DEFAULT_COUNTRY_CODE;
        if (storage.has(LOCAL_STORAGE_KEYS.PREV_COUNTRY_CODE)) {
            defaultCountry = storage.get(LOCAL_STORAGE_KEYS.PREV_COUNTRY_CODE);
        } else {
            defaultCountry = get(privacyPolicyData, "sessionConfigurations.COUNTRYCODE", DEFAULT_COUNTRY_CODE);
        }

        defaultCountry = defaultCountry.toLocaleLowerCase();

        let countryObj = getCountryListData.find((country) => country.countryCode.toLocaleLowerCase() === defaultCountry);
        countryObj = { ...countryObj };
        countryObj.iso2 = defaultCountry === UK_COUNTRY_CODE_NEW ? UK_COUNTRY_CODE_OLD : defaultCountry;
        countryObj.dialCode = countryObj.isoCode.replace("+", "");

        dispatch(setSelectedSmsCountry(countryObj));
        dispatch(setSelectedWhatsAppCountry(countryObj));
    }, [privacyPolicyData, getCountryListData]);

    /*Handle the error handing for isCompany and privacy api */
    useDidMount(() => {
        if (GLOBAL_MEETING_DATA.isCustomDomain) {
            // if the domain is custom domain(ex. webtest.blitzz.app) then handle with company api
            if (isCompanyAvailableData) {
                // Handle the privacy api for set brandColor if the is company api call successfully
                /*
                        set branding color from privacy api if the privacy api call successfull
                        set branding color from iscompany api if the privacy api failed and is company api call successfully
                    */
                if (privacyPolicyData) {
                    setSCSSVariables(privacyPolicyData?.brandingColors);
                } else if (privacyPolicyError) {
                    setSCSSVariables(isCompanyAvailableData?.brandingColors);
                    setShowLoading(false);
                }

                if (!sessionId) {
                    // When the session ID is not present in the URL
                    setSCSSVariables(isCompanyAvailableData?.brandingColors);
                    setShowLoading(false);
                }
            } else if (isCompanyAvailableError) {
                setShowMeBackground(); // Privacy api is not call directly due company api fail so handle to set default background color
                /*
                        if the company api fail and after the main screen it will show a session id input field with default background color
                        so if the user enter the correct session id then it will call the privacy api
                        So if the privacy api call successfully then set a branding color and if failed then set a default back ground color bcz both the privacy and is company api failed
                    */
                if (privacyPolicyData) {
                    setSCSSVariables(privacyPolicyData?.brandingColors);
                } else if (privacyPolicyError) {
                    setShowMeBackground();
                }
            }
        } else if (!GLOBAL_MEETING_DATA.isCustomDomain) {
            // if the domain is global domain (ex. journeydev.blitzz.co) then no need to handle company api
            /*
                    if the domain is global domain then check only privacy api
                    if the privacy api is call successfully then it will set a branding color 
                    if the privacy api failed then set a default background color
                */
            if (privacyPolicyData) {
                setSCSSVariables(privacyPolicyData?.brandingColors);
            } else if (privacyPolicyError) {
                setShowMeBackground();
            }
        }
    }, [isCompanyAvailableData, isCompanyAvailableError, privacyPolicyData, privacyPolicyError, joinMeetingData]);

    //#endregion Local and Custom Hooks

    //#region Local Functions
    const checkForGuestName = () => {
        const askingGuestName = privacyPolicyData?.sessionConfigurations?.ASKGUESTNAME === ENABLED;
        /* If Privacy policy agree and policy parameter for asking guest name is On, than show Ask guest name screen else call Join meeting API */
        if (askingGuestName && !GLOBAL_MEETING_DATA.isAgent && !GLOBAL_MEETING_DATA.pid) {
            setChangeConnectingScreenStep(CONNECTING_SCREEN.ENTER_GUESTNAME_SCREEN);
        } else {
            dispatchJoinMeeting();
        }
    };

    const callJoinMeetingAPI = () => {
        if (isMaxLimitReachedForUploadFiles()) {
            setShowUploadLimitReachedModal(true);
            setShowLoading(false);
            return;
        }

        const req = {
            sessionId: GLOBAL_MEETING_DATA.sessionId || sessionId,
            memberName: GLOBAL_MEETING_DATA.isAgent ? "" : CALL_DATA.participantUserName,
        };

        if (GLOBAL_MEETING_DATA.isAgent) {
            req.userId = GLOBAL_MEETING_DATA.ucid;
        }
        /* requiredRoom key handle if upload only flow available */
        if (PublicVariables.isOnlyUploadImageMeet) {
            req.requiredRoom = false;
        }
        /* handle observer key if observer availab */
        if (CALL_DATA.isObserver && !GLOBAL_MEETING_DATA.isAgent) {
            if (!mediate) {
                req.observer = true;
                googleEvent.logEvent(EVENT_NAME.OBSERVER_JOINED);
                GLOBAL_MEETING_DATA.isGuest = false;
                CALL_DATA.isObserver = true;
            } else if (CALL_DATA.isObserver && mediate) {
                googleEvent.logEvent(EVENT_NAME.MEDIATOR_JOINED);
                GLOBAL_MEETING_DATA.isGuest = true;
                CALL_DATA.isObserver = false;
            }
        }

        const isBrowserSupported = checkSupportedBrowsers();
        if (isBrowserSupported && !rejoinNotllowed()) dispatch(handleJoinMeetingAPI(req));
    };

    /* Handle the privacy policy popup agreed and decline buttons */
    const dispatchJoinMeeting = () => {
        if (privacyPolicyData?.domainName && sessionId && privacyPolicyLoading === false) {
            callJoinMeetingAPI();
        }
    };

    const handlePrivacyPolicyAgreed = useCallback(
        (isAgreed) => {
            GLOBAL_MEETING_DATA.privacyPolicyAgreed = isAgreed;
            if (isAgreed) {
                checkForGuestName();
            }
            setShowPrivacyPolicyModal(false);
        },
        [privacyPolicyData]
    );

    // Auto-accept privacy policy when user clicks "Continue Anyway" in WebView modal
    useEffect(() => {
        if (shouldAutoAcceptPrivacyPolicy) {
            // Reset the flag first to prevent repeated triggers
            dispatch(setShouldAutoAcceptPrivacyPolicy(false));
            // Call the privacy policy agreed handler to proceed with the flow
            handlePrivacyPolicyAgreed(true);
        }
    }, [shouldAutoAcceptPrivacyPolicy, handlePrivacyPolicyAgreed]);

    const handleToShowPrivacyPolicyPopup = () => {
        /* show popup if only the pid is not avaiable in url */
        if (!GLOBAL_MEETING_DATA.isAgent) {
            if (rejoinNotllowed()) {
                // if true then do not allow user to connect call
                return;
            }
            if (GLOBAL_MEETING_DATA.isGuest && privacyPolicyData?.enablePolicyPopup && !GLOBAL_MEETING_DATA.pid) {
                setShowPrivacyPolicyModal(true);
            } else {
                checkForGuestName();
            }
        } else {
            dispatchJoinMeeting();
        }
    };

    const backButtonClickHandler = () => {
        if (changeConnectingScreenStep === CONNECTING_SCREEN.ENTER_GUESTNAME_SCREEN) {
            setChangeConnectingScreenStep(CONNECTING_SCREEN.ENTER_SESSIONID_SCREEN);
        } else if (currentCallBodyScreen === CALL_BODY_SCREEN.UPLOAD_FILE_SCREEN) {
            LogFirebase(FIREBASE_EVENT_CATEGORY.UploadFiles, FIREBASE_LOG_KEY.SendMessage, FIREBASE_LOG_VALUE.UploadFileEndNotification);
            dispatch(changeUploadFileScreen(SELECTED_SCREEN.OFF_VIEW));
            uploadFilesService.sendTrackOnUploadFileStartEnd(UPLOAD_FILE_DATA_TRACK_STATUS.END);
            uploadFilesService.onExitUploadFiles(GLOBAL_MEETING_DATA.markupLiveStream);
            checkPublishVideoOnExit();
            dispatch(updateImagesArray([]));
            /* checkIfLocalTrackReattach(); Not required now as already handle this in service.onExitUploadFiles */
            // Use video-ready detection instead of fixed timeout
            livePointerService.waitForVideoReadyThenExecute(() => {
                // enableLivePointerForMobile sends ENABLED status and auto-starts pointer after
                livePointerService.enableLivePointerForMobile("after_upload_files_back");
            });
        }
    };

    const localisedValuesForCallFooter = useMemo(() => {
        return {
            powered_by: localisedValues?.powered_by,
        };
    }, [localisedValues]);

    const localisedValuesForCallBody = useMemo(() => {
        return {
            unable_to_join_call_please_try_after_sometime: localisedValues?.unable_to_join_call_please_try_after_sometime,
            connecting_your_call: localisedValues?.connecting_your_call,
            finished_uploading: localisedValues?.finished_uploading,
        };
    }, [localisedValues]);

    const topBar = useMemo(() => {
        if (changeConnectingScreenStep !== CONNECTING_SCREEN.UPLOAD_FILES_SCREEN && !isOfflineModeActive) {
            return <CallTopbar changeConnectingScreenStep={changeConnectingScreenStep} backButtonClickHandler={backButtonClickHandler} />;
        }

        return <></>;
    }, [changeConnectingScreenStep, currentCallBodyScreen, isOfflineModeActive]);

    const bottomMenuBar = useMemo(() => <BottomMenuBar />, []);

    const bottomBar = useMemo(() => {
        if (
            changeConnectingScreenStep !== CONNECTING_SCREEN.VIDEO_SCREEN &&
            changeConnectingScreenStep !== CONNECTING_SCREEN.UPLOAD_FILES_SCREEN &&
            currentCallBodyScreen !== CALL_BODY_SCREEN.UPLOAD_FILE_SCREEN &&
            !isOfflineModeActive
        ) {
            return <CallFooter localisedValuesForCallFooter={localisedValuesForCallFooter} />;
        }

        if (
            changeConnectingScreenStep !== CONNECTING_SCREEN.UPLOAD_FILES_SCREEN &&
            currentCallBodyScreen !== CALL_BODY_SCREEN.UPLOAD_FILE_SCREEN &&
            !isOfflineModeActive
        ) {
            return bottomMenuBar;
        }

        return <></>;
    }, [changeConnectingScreenStep, localisedValuesForCallFooter, currentCallBodyScreen, isOfflineModeActive]);

    const onDismissUploadLimitReachedModal = () => {
        setShowUploadLimitReachedModal(false);
    };

    //#endregion Local Functions

    // event trigger when minimized and maximized mWeb app for iOS only
    const handleVisibilityChange = () => {
        // dont check further if call is not connected
        if (!isRemoteParticipantJoined) return;
        LogFirebase("VisibilityChange", "VisibleState", document.visibilityState);
        let tempIsHideVideo = isHideVideo;

        if (document.visibilityState === DOCUMENT_VISIBILITY_STATE.HIDDEN) {
            // for minimized event
            console.log(document.visibilityState);

            if (startLocalVideo && PublicVariables.isIOSDevice) {
                // for front camera
                tempIsHideVideo = true;
                dispatch(setIsHideVideo(true));
            }
            // Show notification when user click anywhere outside at the time of screen sharing
            if (isLocalUserScreenSharing) {
                Notification.requestPermission(function () {
                    if (Notification.permission === "granted") {
                        const notify = new Notification("You`re presenting to everyone", {
                            body: "Click here to return to the video call when you`re ready to stop presenting",
                            icon: GLOBAL_MEETING_DATA.companyLogo,
                            renotify: true,
                            tag: "Blitzz",
                        });
                        notify.onclick = function () {
                            window.parent.focus();
                        };
                    }
                });
            }
        } else if (document.visibilityState == DOCUMENT_VISIBILITY_STATE.VISIBLE) {
            // for maximized event

            if (tempIsHideVideo) {
                if (pointerOn) {
                    livePointerService.turnOffLivePointer(true);
                }

                if (startLocalVideo) {
                    LogFirebase("VisibilityChange", "unpublish VIDEO on visibility change");
                    console.log("unpublish VIDEO on visibility change");
                    unpublishVideo();
                }

                setTimeout(() => {
                    tempIsHideVideo = false;
                    dispatch(setIsHideVideo(false));
                    if (!startLocalVideo) {
                        LogFirebase("VisibilityChange", "publish VIDEO on visibility change");
                        console.log("publish VIDEO on visibility change");
                        publishVideo();
                    }
                }, 100);
            }
            //safari minmize and maximizes ios issue-enable tracks again if mic was on
            if (PublicVariables.isIOSDevice && startLocalAudio) {
                createEnableAudiotracks();
            }
        }
        LogFirebase("VisibilityChange", "HideVideoState", { oldHideVideoState: isHideVideo, updatedHideVideoState: tempIsHideVideo });
        console.log("isHideVideo", isHideVideo);
        dispatch(setIsHideVideo(tempIsHideVideo));
    };

    useEffect(() => {
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
    }, [startLocalVideo, startLocalAudio, pointerOn, isRemoteParticipantJoined]);

    // Handle auto live pointer on expand/collapse view changes
    // Only for DUAL STREAM mode - when agent collapses the expanded view
    useEffect(() => {
        const prevExpandView = prevExpandViewRef.current;
        prevExpandViewRef.current = expandView;

        // Only trigger on actual collapse (from true to false), not on mount
        // And ONLY for dual stream mode - single stream doesn't have collapse behavior
        if (dualStreamEnabled() && livePointerService.isAutoLivePointerEnabled() && GLOBAL_MEETING_DATA.isAgent && isRemoteParticipantJoined) {
            if (prevExpandView === true && expandView === false) {
                // User collapsed the view - turn off auto live pointer (dual stream only)
                console.log("CallScreens: expandView collapsed (dual stream), turning off auto pointer");
                LogFirebase("AutoLivePointer", "expand_view_collapsed", { prevExpandView, expandView });
                livePointerService.livePointerAutomaticOnOff("collaps");
            }
        }
    }, [expandView, isRemoteParticipantJoined]);

    useEffect(() => {
        checkCallSettingPermissionsOnLoad();
    }, []);

    return (
        <ConditionalLDProvider domain={privacyPolicyData}>
            <LDFlagsSync onFlagsReady={setLdFlagsReady} />
            <ProgressLoader />
            <div
                className={clsx(
                    "call",
                    changeConnectingScreenStep !== CONNECTING_SCREEN.VIDEO_SCREEN &&
                        changeConnectingScreenStep !== CONNECTING_SCREEN.UPLOAD_FILES_SCREEN &&
                        "call-connecting",
                    (!isEmpty(videoStreamingUsers) || !isEmpty(screenSharingUsers)) && expandView && "call-single-video"
                )}
                data-testid='connectScreen'
            >
                {(isRoomConnected || isOfflineModeActive) && <MobileSessionInfo />}
                {isOfflineModeActive && !isOfflineModeInProgress && <OfflineModeAlertBox localisedValues={localisedValues} />}
                {isRemoteParticipantJoined && <TimerComponent />}
                {topBar}
                <CallBody
                    handleToShowPrivacyPolicyPopup={handleToShowPrivacyPolicyPopup}
                    changeConnectingScreenStep={changeConnectingScreenStep}
                    localisedValuesForCallBody={localisedValuesForCallBody}
                    dispatchJoinMeeting={dispatchJoinMeeting}
                />
                {bottomBar}
            </div>
            <CustomToastModal />
            {isInviteModalOpen && <InviteParticipant />}
            {isRoomConnected && <SessionInfoSidebar />}
            {showPrivacyPolicyModal && <PrivacyPolicy handlePrivacyPolicyAgreed={handlePrivacyPolicyAgreed} />}
            {(joinMeetingData?.sessionConfigurations || joinMeetingError) && <JoinMeeting />}
            {room && <TwilioRoomEvent />}
            {GLOBAL_MEETING_DATA.isAgent && PublicVariables.featureFlag?.SHOWMENOTES === ENABLED && <NotesDrawer />}
            {containerImagesArray.length > 0 && <ImageContainerDrawer showContainerView={false} />}
            {extractTextInprogress !== EXTRACT_TEXT_VIEW.OFF_VIEW && <ExtractText />}
            {(extractTextInprogress === EXTRACT_TEXT_VIEW.OCR_VIEW || markupInprogress === MARKUP_VIEW.START_MARKUP_VIEW) && (
                <DownloadImageFailedModal />
            )}
            {(markupInprogress === MARKUP_VIEW.START_MARKUP_VIEW || markupLiveStream) && <ConfirmExitMarkupModal />}
            {(extractTextInprogress === EXTRACT_TEXT_VIEW.OCR_VIEW ||
                markupInprogress === MARKUP_VIEW.START_MARKUP_VIEW ||
                pointerOn ||
                arMarkupService.checkARMarkupIsOngoing() ||
                markupLiveStream) && <OrientationChangeModal />}
            {openCopyTextModal && <ExtractTextCopyModal />}
            {(markupLiveStream || markupInprogress !== MARKUP_VIEW.OFF_VIEW || arMarkupService.checkARMarkupIsOngoing()) && <Markup />}
            <ARMarkupStatusPopup />
            <Measurement />
            {subScreenToShow === SUB_SCREEN.CAMERA_VIEW && <UploadFileContainerDrawer />}
            {GLOBAL_MEETING_DATA.isAgent && PublicVariables.featureFlag?.SHOWMEBOOKMARK && <BookmarkDrawer />}
            {!countinueWithWeb && <AskGuestUserPopup />}
            {showUploadLimitReachedModal && <UploadLimitReachedModal onDismissModal={() => onDismissUploadLimitReachedModal()} />}
            {showLocationPermissionPopup && <LocationPermissionPopup />}
            {(notAllowedCamera || isConfirmVideoModalOpen) && <VideoPermissionPopup />}
            {(audioErrorModal || showPopupForPlayAudio) && <AudioErrorModals />}
            <ChatDrawer />
            <AskAIDrawer />
            {(strStartsIn || strStartsIn == "") && <ScheduleSessionModal dispatchJoinMeeting={dispatchJoinMeeting} />}
            {GLOBAL_MEETING_DATA.isAgent && <ParticipantsListDrawer />}
            <canvas style={{ display: "none" }} id='screenshotcanvas'></canvas>
            {isSilentObserverAvailable() && isRemoteParticipantJoined && <SilentObserverNotificationModal />}
            <DeviceBattery />
            <DeviceNetwork />
            <AppDownloadModal />
            <MediatePopup />
            {isRemoteParticipantJoined && <ScreenSharePopUp />}
            {confirmDisconnectCall && <EndCall />}
            {showCallDisconnectedPopup && <LastUserDisconnectPopup />}
            <UnSupportedBrowserModal />
            {removeParticipant?.isRemoveModalOpen && <RemoveIndividualParticipantByHost />}
            {removeParticipant?.isRemoveAllModalOpen && <RemoveAllParticipantsByHost />}
            {isUnableToJoinCallModalOpen && <UnableToJoinCallModal />}
            {isRoomParticipantExceed && (
                <RoomErrorModals
                    isRoomParticipantExceed={isRoomParticipantExceed}
                    joinMeetingData={joinMeetingData}
                    dispatchJoinMeeting={dispatchJoinMeeting}
                />
            )}
            {isRemoteParticipantJoined && <CommonNotificationModal />}
            {isIosPlayPauseIconModalOpen && <IosPlayPauseIconModal />}
            {isRemoteParticipantJoined && <RequestPermissionForMicOrCameraModal />}
            {(isRoomConnected || isOfflineModeActive) && (
                <Beforeunload onBeforeunload={() => localisedValues?.are_you_sure_you_want_to_close_window} />
            )}
            {isRemoteParticipantJoined && <LiveCaptions />}
            {isRemoteParticipantJoined && <AudioTranslationStatus />}
            <AudioTranslationDrawer />
            <CallSettingDrawer />
            <OfflineMode />
        </ConditionalLDProvider>
    );
};

export default CallScreens;
